import { render, staticRenderFns } from "./PageInput.vue?vue&type=template&id=0bf5198b"
import script from "./PageInput.vue?vue&type=script&lang=js"
export * from "./PageInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports